import BootstrapField from '../utility/BootstrapField';
import IsEqual from 'lodash.isequal';

let originalOrganizationData = null;

export default class NewPrimaryOrganization {
    constructor(data) {
        if (!data) {
            data = {};
        }

        Object.assign(this, {
            name: new BootstrapField({
                value: data.name || null,
                required: true,
            }),

            domain: new BootstrapField({
                value: data.domain || null,
                required: true,
            }),

            isActive: new BootstrapField({
                value: data.isActive || null,
                required: true,
            }),

            organizationTypeId: new BootstrapField({
                value: data.organizationTypeId || null,
                required: true,
            }),

            comments: new BootstrapField({
                value: data.comments || null,
            }),

            username: new BootstrapField({
                value: data.username || null,
            }),

            firstName: new BootstrapField({
                value: data.firstName || null,
                required: true,
            }),

            lastName: new BootstrapField({
                value: data.lastName || null,
                required: true,
            }),

            password: new BootstrapField({
                value: data.password || null,
            }),

            title: new BootstrapField({
                value: data.title || null,
            }),

            email: new BootstrapField({
                value: data.email || null,
                required: true,
            }),

            phone: new BootstrapField({
                value: data.phone || null,
                required: true,
            }),

            altPhone: new BootstrapField({
                value: data.altPhone || null,
            })
		});
		
		originalOrganizationData = this.getRawValue();
    }

    validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);
		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getRawValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);
		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {

		// var differences = DeepDiff.diff(originalOrganizationData.getRawValue(),  this.getRawValue());

		return !IsEqual(originalOrganizationData, this.getRawValue());
		// return false;
	}
	revertChanges() {
		this.constructor(originalOrganizationData);
	}
	saveChanges() {
		// originalOrganizationData = CloneDeep(this);
		originalOrganizationData = this.getRawValue();
	}
}